import script from "./page-search.vue?vue&type=script&setup=true&lang=js"
export * from "./page-search.vue?vue&type=script&setup=true&lang=js"

import "./page-search.vue?vue&type=style&index=0&id=ca6577b2&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\wisecard\\smart-tms-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca6577b2"]])

export default __exports__